import { rootStore } from "src/store";
import { supportedLanguages } from "src/constants/locale.constants";
import { SupportedLocalesModel } from "src/models";

export const setupLocale = () => {
  const newGemHubLang = new URLSearchParams(window.location.search).get("lang");
  if (newGemHubLang) {
    const normalizedValue = newGemHubLang.toLowerCase().replace(/-/g, "_");
    if (supportedLanguages.includes(normalizedValue as any)) {
      rootStore.stores.localeStore.fetchLocale(normalizedValue as SupportedLocalesModel, true);
      return;
    }
  }

  // If there is locale code in localStorage AND it's supported by us
  // -> download that locale
  const localStorageLocaleCode = localStorage.getItem("localeCode");
  const normalizedLocalStorageLocaleCode = localStorageLocaleCode?.toLowerCase().replace(/-/g, "_");
  if (
    normalizedLocalStorageLocaleCode &&
    supportedLanguages.includes(normalizedLocalStorageLocaleCode as any)
  ) {
    rootStore.stores.localeStore.fetchLocale(
      normalizedLocalStorageLocaleCode as SupportedLocalesModel,
      true,
    );
  } else {
    // If there is no locale in localStorage
    // -> look browser default language
    // If browser language supported by us -> download it
    // If not -> download default english locale
    const browserLanguageParts = window.navigator.language.replace(/_/g, "-").split("-");
    const language = browserLanguageParts[0]?.toLowerCase() || "en";
    const region = browserLanguageParts
      .slice(1)
      .reverse()
      .find((part) => part.length === 2)
      ?.toLowerCase();
    const localeWithRegion = region ? `${language}_${region}` : language;

    const localeToUse = supportedLanguages.includes(localeWithRegion as any)
      ? (localeWithRegion as SupportedLocalesModel)
      : supportedLanguages.includes(language as any)
      ? (language as SupportedLocalesModel)
      : "en";

    rootStore.stores.localeStore.fetchLocale(localeToUse, true);
  }
};
